import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'

import { msalInstance } from './authConfig'
import App from './components/app/App'
import { ErrorFallback } from './components/app/ErrorFallback'
import { ConfigureInterceptors } from './interceptors/request-interceptor'
import { FullStoryPayload } from './utils/fullstory'

import './index.scss'

// Cant use JSONSchema7 as enum names is not supported
// https://github.com/rjsf-team/react-jsonschema-form/issues/2663#issuecomment-1106698186
declare module 'json-schema' {
    export interface JSONSchema7 {
        enumNames?: string[]
    }
}

declare global {
    interface Window {
        documentPictureInPicture: any
        FS?: (method: string, payload: FullStoryPayload) => void
    }
}

ConfigureInterceptors()

const root = createRoot(document.getElementById('root')!)

// msal-browser v3+ requires initialize() before any other API call (e.g. getToken
// in the axios interceptor); waiting here removes the race MsalProvider would leave open
void msalInstance
    .initialize()
    .then(() => {
        root.render(
            <Router>
                <MsalProvider instance={msalInstance}>
                    <App />
                </MsalProvider>
            </Router>
        )
    })
    .catch((error) => {
        // Nothing else renders if this rejects, and Datadog RUM only starts inside App —
        // so without this the failure is a permanently blank page with zero telemetry.
        // ErrorFallback is safe to render here: it pulls in react-bootstrap only, no
        // store, router or auth context.
        console.error('MSAL initialization failed:', error)

        root.render(<ErrorFallback error={error} resetErrorBoundary={() => window.location.reload()} />)
    })
